import {SET_HEADQUARTERS_LIST} from '../mutation-types';
import {getHeadquarters} from '@/api/headquarters-api';

const initialState = {
    list: []
};

const getters = {
    headquartersById: state => (headquartersId) => {
        return state.list.find(headquarters => (headquarters.uuid === headquartersId));
    },
    getHeadquartersList: (state, getters) => {
      return state.list;
    }
};

const mutations = {
    [SET_HEADQUARTERS_LIST](state, headquarters) {
        state.list = headquarters;
    }
};

const actions = {
    loadHeadquarters({commit}) {
        return new Promise((resolve, reject) => {
            getHeadquarters()
                .then(headquarters => {
                    commit(SET_HEADQUARTERS_LIST, headquarters);
                    resolve(true);
                })
                .catch(() => {
                    reject(false);
                });
        });
    }
};

export default {
    state: initialState,
    getters,
    mutations,
    actions
}
